import { number, object } from "prop-types";
import { useTranslation } from "react-i18next";
import {
  useEstimateEditorSettings,
  ExpandContainer,
  PinnableCell,
  TeamMembersTag,
  WorkTypeResourceSelect,
} from "@tools";
import { Grid } from "@material-ui/core";
import { TimelineNestedRowActions } from "./TimelineNestedRowActions";
import classnames from "classnames";

export const TitleCell = ({
  resource,
  tableDepth,
}) => {
  const { t } = useTranslation();
  const { allowEdition } = useEstimateEditorSettings();
  
  const { name, teamMembers, usesTimelinePercent } = resource;
  
  return (
    <PinnableCell
      boldText
      colName="title"
      pinnedLeft
      hasStaticWidth
      tableDepth={2}
      allowOverflowDisplay
      actions={
        <TimelineNestedRowActions
          resource={resource}
          parentUsesTimelinePercent={usesTimelinePercent}
        />
      }
      containers={ <ExpandContainer tableDepth={tableDepth} /> }
    >
      {allowEdition ? (
        <WorkTypeResourceSelect
          resource={resource}
          noMinWidth
          displayTeamMembers
          timelineAutofocus
          navigationKey="tm-name"
        />
      ) : (
        <Grid
          item
          container
          alignItems="center"
          className={classnames(
            "name",
            "preset-timelineTitleText",
            !name?.length && "semi-transparent"
          )}
        >
          {name || t("common.unnamed")}
          <TeamMembersTag teamMembers={teamMembers} />
        </Grid>
      )}
    </PinnableCell>
  )
}

TitleCell.propTypes = {
  resource: object.isRequired,
  tableDepth: number.isRequired,
}